/* eslint-disable prettier/prettier */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import ACTIVECHATCOUNTSUBSCRIPTION from "src/graphql/subscriptions/dashboard/activechatcountchanged";
import ActiveChatsImg from "src/assets/images/dashboard/activeChatsIcon.png";
import { useLazyQuery, useSubscription } from "@apollo/client";
import { useSnackbar as Snackbar } from "notistack";
import { UseDashboardContext } from "src/context/dashboard";
import { safeJsonParse } from "src/utils/shared/safeJson";
import GETUSERACTIVECHATCOUNTS from "src/graphql/query/dashboard/FigureCards/getUserActiveChatCount";
import GeneralCard from "../GeneralCard";

const ActiveChats = () => {
  const { enqueueSnackbar } = Snackbar();
  const contextData = UseDashboardContext();

  let activeChats: number = 0;
  let storedAgentId: number = 0;
  let globalTimeFrame: string = "today";
  let setActiveChats: (a: number) => void;

  if (contextData) {
    ({ activeChats, setActiveChats, storedAgentId, globalTimeFrame } =
      contextData);
  }

  const [
    getActiveChatCounts,
    {
      data: getUserTotalChatCountsData,
      loading: getUserTotalChatCountsLoading,
    },
  ] = useLazyQuery(GETUSERACTIVECHATCOUNTS, {
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    if (storedAgentId) {
      getActiveChatCounts({
        variables: {
          agentId: [storedAgentId],
          timeFrame: globalTimeFrame,
        },
      });
    }
  }, [storedAgentId, globalTimeFrame]);

  useEffect(() => {
    if (
      getUserTotalChatCountsData &&
      getUserTotalChatCountsData.getUserActiveChatCount
    ) {
      if (getUserTotalChatCountsData.getUserActiveChatCount.success) {
        setActiveChats(getUserTotalChatCountsData.getUserActiveChatCount.count);
      } else {
        enqueueSnackbar(
          getUserTotalChatCountsData.getUserActiveChatCount.error,
          {
            variant: "error",
          },
        );
      }
    }
  }, [getUserTotalChatCountsData]);

  //
  const {
    data: activechatcountchangedSubscriptionResult,
    error: activechatcountchangedSubscriptionError,
  } = useSubscription(ACTIVECHATCOUNTSUBSCRIPTION);

  useEffect(() => {
    if (activechatcountchangedSubscriptionError) {
      enqueueSnackbar(activechatcountchangedSubscriptionError.message, {
        variant: "error",
      });
    }
  }, [activechatcountchangedSubscriptionError]);

  useEffect(() => {
    if (
      activechatcountchangedSubscriptionResult &&
      globalTimeFrame === "today"
    ) {
      const { count, agentId } = safeJsonParse<any>(
        activechatcountchangedSubscriptionResult.activechatcountchanged.result,
        { count: 0, agentId: null },
        "Active Chats",
      );
      if (storedAgentId === Number(agentId)) setActiveChats(count);
    }
  }, [activechatcountchangedSubscriptionResult]);

  return (
    <GeneralCard
      tourId="tour-dashboard-active-card"
      cardImage={ActiveChatsImg}
      count={activeChats}
      loader={getUserTotalChatCountsLoading}
      dropDownValues={globalTimeFrame}
      hideDropdown
      title="Active Chats"
    />
  );
};

export default ActiveChats;
